module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="hotelTour__rooms js-open-tour-info-by-room-photo">\n	';
 if(photos && photos.length) {
		var lengthPhoto = photos.length > 2 ? 2 : photos.length;
		for(var i = 0; i < lengthPhoto; i++) { 
__p+='\n			<div class="hotelTour__room"><img src="'+
((__t=( imageProxy(photos[i],{width:102,height:74}) ))==null?'':__t)+
'" ></div>\n		';
 } 
__p+='\n	';
 } 
__p+='\n</div>';
}
return __p;
};
